// extracted by mini-css-extract-plugin
export default {"container":"style_container__pyxKK","icon":"style_icon__DOXW1","title_input_container":"style_title_input_container__iGOEd","submit_btn":"style_submit_btn__jtJOm"};